import List from "./List";
import New from "./New";
import Detail from "./Detail";
import Wrapper from "./Wrapper";

export default {
  List,
  New,
  Wrapper,
  Detail
};
